import React from 'react';
import { Loading } from '/imports/ui/Loading';

type LoadingFullScreenProps = {
  caption?: string
};

export const LoadingFullScreen = (props: LoadingFullScreenProps = {}) => (
  <div className="loading-fullscreen fixed top-0 left-0 z-1000 flex h-full w-full flex-col justify-around bg-page">
    <Loading caption={props.caption} />
  </div>
);
